import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Box, Container, CircularProgress } from '@mui/material';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './components/LoginPage';
import ReportsPage from './components/ReportsPage';
import ReportPage from './components/ReportPage';
import Header from './components/Header';
import Footer from './components/Footer';

function AppRoutes() {
  const { isAuthenticated, logout, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header isAuthenticated={isAuthenticated} onLogout={logout} />
      <Container component="main" sx={{ mt: 4, mb: 4 }}>
        <Router>
          <Routes>
            <Route
              path="/"
              element={isAuthenticated ? <Navigate to="/reports" /> : <LoginPage />}
            />
            <Route
              path="/reports"
              element={isAuthenticated ? <ReportsPage /> : <Navigate to="/" />}
            />
            <Route
              path="/report/:reportId"
              element={isAuthenticated ? <ReportPage /> : <Navigate to="/" />}
            />
            <Route
              path="/report/:reportId/-/*"
              element={isAuthenticated ? <ReportPage /> : <Navigate to="/" />}
            />
          </Routes>
        </Router>
      </Container>
      <Footer />
    </Box>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
